"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDrugMasterSchema = exports.createDrugMasterSchema = exports.drugMasterShape = void 0;
const zod_1 = require("zod");
// Legacy drug codes (e.g. "DRG-2026-000123") predate the switch to plain
// numeric codes — kept loose here so editing an existing drug (which
// round-trips its own unchanged drugCode through the update payload)
// never fails validation. `createDrugMasterSchema` below overrides this
// with the stricter numeric-only rule for newly created drugs.
const legacyDrugCode = zod_1.z.string().min(1).max(30).optional();
exports.drugMasterShape = {
    drugCode: legacyDrugCode,
    genericName: zod_1.z.string().min(1).max(255),
    brandName: zod_1.z.string().max(255).optional(),
    categoryId: zod_1.z.string().uuid().optional(),
    dosageFormId: zod_1.z.string().uuid().optional(),
    routeId: zod_1.z.string().uuid().optional(),
    strength: zod_1.z.string().max(50).optional(),
    manufacturer: zod_1.z.string().max(255).optional(),
    isNarcotic: zod_1.z.boolean().default(false),
    // Stage 14, Phase 1 (Pharmacy Master Data Foundation) — additive, ADR-030.
    genericMasterId: zod_1.z.string().uuid().optional(),
    brandMasterId: zod_1.z.string().uuid().optional(),
    manufacturerMasterId: zod_1.z.string().uuid().optional(),
    stockCategoryId: zod_1.z.string().uuid().optional(),
    scheduleId: zod_1.z.string().uuid().optional(),
    storageConditionId: zod_1.z.string().uuid().optional(),
    strengthId: zod_1.z.string().uuid().optional(),
    purchaseUnitId: zod_1.z.string().uuid().optional(),
    issueUnitId: zod_1.z.string().uuid().optional(),
    packagingHierarchyTemplateId: zod_1.z.string().uuid().optional(),
    conversionFactor: zod_1.z.number().positive().optional(),
    packSize: zod_1.z.string().max(50).optional(),
    taxTypeId: zod_1.z.string().uuid().optional(),
    hsnCode: zod_1.z.string().max(10).optional(),
    atcCode: zod_1.z.string().max(20).optional(),
    temperatureRangeMinCelsius: zod_1.z.number().optional(),
    temperatureRangeMaxCelsius: zod_1.z.number().optional(),
    shelfLifeMonths: zod_1.z.number().int().positive().optional(),
    isControlledDrug: zod_1.z.boolean().default(false),
    isHighAlertDrug: zod_1.z.boolean().default(false),
    isLasaDrug: zod_1.z.boolean().default(false),
    isPrescriptionRequired: zod_1.z.boolean().default(false),
    isInternalOnly: zod_1.z.boolean().default(false),
    pregnancyCategoryId: zod_1.z.string().uuid().optional(),
    lactationCategoryId: zod_1.z.string().uuid().optional(),
    pharmacologicalClassId: zod_1.z.string().uuid().optional(),
    barcodeValue: zod_1.z.string().max(100).optional(),
    effectiveDate: zod_1.z.coerce.date().optional(),
    remarks: zod_1.z.string().optional(),
    lifecycleStatus: zod_1.z.enum(['AVAILABLE', 'DISCONTINUED', 'RECALLED', 'EXPIRED_PRODUCT', 'UNDER_REVIEW']).optional(),
};
exports.createDrugMasterSchema = zod_1.z.object({
    ...exports.drugMasterShape,
    drugCode: zod_1.z
        .string()
        .regex(/^\d{1,6}$/, 'Drug code must be numeric, up to 6 digits')
        .optional(),
});
exports.updateDrugMasterSchema = zod_1.z.object(exports.drugMasterShape).partial();
//# sourceMappingURL=drug-master.schema.js.map